// eslint-disable-next-line vymo-ui/restrict-import
import { REVYRE } from 'src/modules/revyre/constants';

export { REVYRE };

export const STATE_ID = 'stateId';
export const CASE = 'ccase';
export const LOAN = 'loan';

export const TAB_STATUS_KEYS = {
  RELATED_RECORDS: 'relatedRecords',
  DETAILS: 'details',
  AUDIT_HISTORY: 'auditHistory',
  TRAILS: 'trails',
  CASES: 'cases',
  HISTORY: 'history',
  ACTIVE_CASES: 'activeCases',
  SUSPENDED_CASES: 'suspendedCases',
  SUPERVISOR_REVIEW: 'supervisorReview',
};

export const DISPOSITION_GROUP = 'outcomeGroup';
